import { getCookies, setCookies } from './cookieHelpers'

/**
 * Pre-launch live-attendance testing.
 *
 * A secret token in the URL (?live=<token>) enables the "Atendimento ao vivo —
 * agora" option for the current visitor only — the backend injects the live item
 * into GET /api/v1/doctors solely when the request carries the matching
 * live_preview token (see doctors_controller#valid_live_preview_token?). Without
 * the flag, the live flow stays dormant for everyone else.
 *
 * The token is persisted to a cookie so it survives navigation through the whole
 * flow (the live option appears during doctor selection, then continues).
 */
const LIVE_PREVIEW_COOKIE = 'livePreviewToken'
const LIVE_PREVIEW_TTL_HOURS = 24

/** Read ?live=<token> from the current URL and persist it (if present). */
export const captureLivePreviewToken = (): void => {
  if (typeof window === 'undefined') return
  const token = new URLSearchParams(window.location.search).get('live')
  if (token) {
    setCookies({ name: LIVE_PREVIEW_COOKIE, value: token, expirationHours: LIVE_PREVIEW_TTL_HOURS })
  }
}

/** The persisted live-preview token, or null if testing isn't enabled for this visitor. */
export const getLivePreviewToken = (): string | null => {
  const { value } = getCookies(LIVE_PREVIEW_COOKIE)
  return value || null
}
